import { createSelector } from '@reduxjs/toolkit';

import { TRootState } from '../index';
import { ICurrentCounsellorState } from './current-counsellor.slice';

/**
 A selector function to retrieve the current counsellor profile data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {ICurrentCounsellorState} The current counsellor state object from the Redux store
 */
const selectCurrentCounsellorState = (state: TRootState): ICurrentCounsellorState => state.currentCounsellor;

/**
 A memoized selector function to retrieve the current counsellor profile data from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, ICurrentCounsellorState, (res: ICurrentCounsellorState) => ICurrentCounsellorState>}
 */
export const getCurrentCounsellorState = createSelector(
  [selectCurrentCounsellorState],
  (state): ICurrentCounsellorState => state
);
